<template>
    <div class="wp">
        <div class="w-1200 p-d-1"> 
            <div class="title-more">
                <i class="el-icon-s-home" style="color:#615E61;position:relative;top:16px;left:10px;"> </i>
                <el-breadcrumb style="width:90%;padding-left:40px;"  separator=" - ">
                        <el-breadcrumb-item :to="{path:'/home'}">首页</el-breadcrumb-item>
                        <el-breadcrumb-item :to="{path:'/productCenter'}">示范产品</el-breadcrumb-item>
                        <el-breadcrumb-item>产品详情</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="box-bottom">
                <div class="d-1">
                    <div class="img pull-left">
                        <el-image style="width: 100%; height: 100%" :src="detail.fgpic" fit="contain"></el-image>
                        <!-- <img :src="detail.fgpic"> -->
                    </div>
                    <div class="right">
                        <p class="p1">{{detail.pname}}</p>
                        <div class="item i-color">
                            <p class="p-l pull-left">品牌</p>
                            <p class="p-r pull-right">{{detail.brand}}</p>
                        </div>
                        <div class="item">
                            <p class="p-l pull-left">型号</p>
                            <p class="p-r pull-right">{{detail.model}}</p>
                        </div>
                        <div class="item i-color">
                            <p class="p-l pull-left">产地</p>
                            <p class="p-r pull-right">{{detail.placeProvince_text}}{{detail.placeCity_text}}</p>
                        </div>
                        <div class="item">
                            <p class="p-l pull-left">产品注册号</p>
                            <p class="p-r pull-right">{{detail.registNum}}</p>
                        </div>
                        <div class="item i-color">
                            <p class="p-l pull-left">用途</p>
                            <p class="p-r pull-right">{{detail.purpose}}</p>
                        </div>
                        <!-- <div class="item">
                            <p class="p-l pull-left">招商状态</p>
                            <p class="p-r pull-right">{{detail.}}</p>
                        </div>
                        <div class="item i-color">
                            <p class="p-l pull-left">招商区域</p>
                            <p class="p-r pull-right">全国</p>
                        </div> -->
                        <div class="item">
                            <p class="p-l pull-left">浏览量</p>
                            <p class="p-r pull-right">{{detail.scanNum}}</p>
                        </div>
                        <el-button type="primary" style="background:linear-gradient(-90deg,rgba(242,174,56,1),rgba(255,149,0,1));border:0;margin-left:20px;margin-top:20px;" icon="el-icon-edit-outline" @click="dialogVisible=true">我要招商，留言</el-button>
                    </div>
                </div>
                <div class="d-2">
                    <div class="title-triangle">
                        <p class="t-t-t active">产品描述</p>
                        <!-- <p class="t-t-t">招商说明</p> -->
                        <div class="triangle"></div>
                    </div>
                    <div class="box-bottom">
                        <div class="p-d">
                            <com-richtext :richtext="detail.fgnr"></com-richtext>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
        class="leave-message"
            title="我要留言"
            :visible.sync="dialogVisible"
            width="50%"
            >
            <!-- <p class="l-m-p1" style="boxShadow:0 5px 0 0 #F6F3F7;">
                "<span style="color:#066BD1;">多材料医疗3D打印机</span>"的留言，共<span style="color:#FF0000;">12</span>条
            </p> -->
            <com-leave-word :chatId="chatId" :source="source"></com-leave-word>
            
        </el-dialog>
    </div>
    
</template>
<script>
import ProductDetail from './ProductDetail.js';
export default ProductDetail;
</script>
<style lang="scss" scoped>
@import './ProductDetail.scss';
</style>